import { NavLink, NavLinkProps } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import type { Theme } from '@bizzabo/design-system';
import { useStyles as useDrawerLinkStyles } from '../DrawerLinkBase/styles';
import cn from 'clsx';

const DrawerNavLink: React.FC<NavLinkProps> = ({ children, className, ...navLinkProps }) => {
    const drawerLinkClasses = useDrawerLinkStyles();
    const classes = useStyles();
    return (
        // TODO: Moshe validate this logic with QA
        <NavLink
            className={navData =>
                cn(drawerLinkClasses.drawerLink, className, {
                    [classes.linkActive]: navData.isActive,
                })
            }
            {...navLinkProps}
        >
            {children}
        </NavLink>
    );
};

export const useStyles = makeStyles<Theme>(
    theme => ({
        linkActive: {
            '&::after': {
                position: 'absolute',
                content: '""',
                height: 2,
                backgroundColor: theme.customization.background.G10,
                bottom: -4,
                left: 0,
                right: 0,
            },
        },
    }),
    { classNamePrefix: 'drawer-nav-link' }
);

export default DrawerNavLink;
